export default "__VITE_ASSET__BPNTDM6p__"